import IConfiguration from "../../../types/IConfiguration";
import IConfigurationService from "../../spi/IConfigurationService";
import FirebaseService from "./FirebaseService";

export default class FirebaseConfigurationService implements IConfigurationService {

  async getConfigurations(): Promise<Array<IConfiguration>> {
    let Configurations: Array<IConfiguration> = [];
    try {
      const snapshot = await FirebaseService.getInstance()
        .configurations()
        .get()
      snapshot.forEach((child: any) => {
        const configuration:IConfiguration = child.data();
        configuration.uid = child.id
        Configurations.push(configuration)
      });
    }
    catch (ex) {
      console.log(ex)
      throw ex;
    }
    return Configurations;
  }

  async getConfiguration(code: string): Promise<IConfiguration> {
    let temp: IConfiguration = {} as IConfiguration;
    if (!code) {
      return temp
    }
    try {
      const snapshot = await FirebaseService.getInstance()
        .configuration(code).get()
        if(snapshot.data()){
          temp = snapshot.data();
          temp.uid = snapshot.id;
        }
    }
    catch (ex) {
      throw ex;
    }
    return temp;
  }

  async createConfiguration(configuration: IConfiguration): Promise<IConfiguration> {
    let temp: IConfiguration = {} as IConfiguration;
    try {
      FirebaseService.getInstance().configurations().doc().set(configuration);
      temp = configuration;
    }
    catch (ex) {
      console.log(ex)
      throw ex;
    }
    return temp;
  }

  async updateConfiguration(Configuration: IConfiguration): Promise<Boolean> {
    if (Configuration == undefined)
      return false
    try {
      const { ...ConfigurationSnapshot } = Configuration;
      await FirebaseService.getInstance()
        .configuration(Configuration.uid)
        .update({
          ...ConfigurationSnapshot
        })
    }
    catch (ex) {
      throw ex;
    }
    return true;
  }

}